import { useAlarmTypes } from '@services/alarm'
import { isNotNil } from '@shared/innmaxLib/utils/webHelper'
import { Select, SelectProps } from '@shared/innmaxUI/Form/Select'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  filterByDeviceType?: boolean
  deviceType?: string
  showAllWhenDeviceTypeNil?: boolean
} & SelectProps

export const AlarmTypeSelect = React.forwardRef<typeof Select, Props>(
  (
    {
      getFieldDecorator,
      initialValue,
      filterByDeviceType,
      deviceType,
      showAllWhenDeviceTypeNil,
      ...props
    }: any,
    ref
  ): any => {
    const { t } = useTranslation()

    const { alarmTypes } = useAlarmTypes()

    const options = React.useMemo(() => {
      if (!filterByDeviceType) {
        return alarmTypes
      }

      if (!deviceType) {
        return showAllWhenDeviceTypeNil ? alarmTypes : []
      }

      return alarmTypes.filter(i =>
        isNotNil(i.deviceTypesVsCtrlerTypes[deviceType])
      )
    }, [alarmTypes, filterByDeviceType, deviceType])

    return (
      <Select
        forwardRef={ref}
        allowClear
        placeholder={t('system:select alarm condition')}
        {...props}>
        {options?.map(x => (
          <Select.Option key={x.value} value={x.value}>
            {x.desc}
          </Select.Option>
        ))}
      </Select>
    )
  }
)

export default AlarmTypeSelect
